import AddIcon from '@mui/icons-material/Add';
import CreateIcon from '@mui/icons-material/Create';
import { Paper, Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { Box } from '@mui/system';
import { observer } from 'mobx-react';
import React, { Fragment, useEffect, useState } from 'react';

import { ProjectButtonLink } from '../../../../design/link/ProjectButtonLink';
import { IAdminPageProperties } from '../../IAdminPageProperties';
import { ConnectionViewBox } from './ConnectionViewBox';
import { MailAdminDomain } from './store/MailAdminDomain';

export interface ActiveDirectoryAdminTableProperties extends IAdminPageProperties {}

export const ConnectionPage = observer(({ layoutDomain }: ActiveDirectoryAdminTableProperties) => {
  const [domain] = useState(new MailAdminDomain(layoutDomain));
  const classes = useStyles();

  useEffect(() => {
    domain.loadData();
  }, []);

  return (
    <Fragment>
      {domain.ui.isCanCreate.value && (
        <Paper className={classes.root} elevation={3}>
          {domain.ui.isEmptySettings.value ? (
            <ProjectButtonLink icon={<AddIcon />} url={`/settings/mail/server/new`}>
              Добавить почту
            </ProjectButtonLink>
          ) : (
            <ProjectButtonLink icon={<CreateIcon />} url={`/settings/mail/server/new`}>
              Редактировать почту
            </ProjectButtonLink>
          )}
        </Paper>
      )}
      {domain.ui.isEmptySettings.value ? <Box>Нет данных</Box> : <ConnectionViewBox mailDomain={domain} />}
    </Fragment>
  );
});

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    padding: theme.spacing(2),
  },
}));
